import { AbstractEntityMapper } from '@pf/shared-services';
import {
    WarehouseCreate,
    WarehouseDto,
    WarehouseRead,
    WarehouseSearchParams,
} from '../../entities/warehouse.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { WarehouseMetadataMap } from './warehouse.mapping-profile';

@Injectable()
export class WarehouseMapper extends AbstractEntityMapper<
    WarehouseRead,
    WarehouseCreate,
    WarehouseDto,
    WarehouseSearchParams
> {
    constructor() {
        super(WarehouseDto, PlatformWmsMapper, WarehouseMetadataMap.symbols);
    }
}
